module Invoices

open Elmish
open Fable.Core
open Fable.React
open Fable.React.Props
open Fetch

open OnlineDPR.Application.Client.Components
open OnlineDPR.Application.Client.InvoiceComponents
open OnlineDPR.Application.Shared

open OnlineDPR.Application.Client

[<Emit("InvoicesDataSource")>]
let invoicesDataSource : string = jsNative

type Msg =
| FetchInvocies
| ChangeSearchTerm of string
| UpdateSortOption of InvoiceSortOption
| ParseInvoicesDataList of Result<Invoice list, string>

let init() = InvoicesModel { Invoices = []
                             Searchterm = ""
                             SortOption = { Column = InvoiceSortColumn.Date
                                            Order = InvoiceSortOrder.Descending } }, []

let fetchInvoicesPromise searchterm = Http.fetchAs<Invoice list> (sprintf "%s%s%s" invoicesDataSource "?searchterm=" searchterm)  [ Credentials RequestCredentials.Include ]
let fetchInvocies searchterm =
    Cmd.OfPromise.either
        fetchInvoicesPromise
        searchterm
        ParseInvoicesDataList
        ((fun e -> Error (string e) ) >> ParseInvoicesDataList)

let update msg (model: InvoicesModel) =
    match msg with
    | FetchInvocies -> model, (fetchInvocies model.Searchterm)
    | ChangeSearchTerm term -> { model with Searchterm = term }, []
    | ParseInvoicesDataList (Ok data) -> {model with Invoices = data}, []
    | ParseInvoicesDataList (Error ex) -> model, []
    | UpdateSortOption newOption -> { model with SortOption = newOption }, []

type InvoiceSearchFormComponentProps = { placeholder: string; dispatch: Msg -> unit }
let invoiceSearchForm ({placeholder = placeholder; dispatch=dispatch }:InvoiceSearchFormComponentProps) =
    form [ ClassName "form-inline mb-2" ]
         [ div [ ClassName "form-group full-width" ]
               [ label [] [ str "Filter" ]
                 input [ ClassName "form-control col-5"
                         DefaultValue placeholder
                         OnKeyPress (fun ev -> match ev.key with
                                               | "Enter" -> ev.preventDefault()
                                                            dispatch FetchInvocies
                                               | _ -> ())
                         OnChange (fun ev -> dispatch (ChangeSearchTerm ev.Value))
                         Placeholder "B2B-Nummer, Clubnummer, Rechnungsnummer oder Datum"]
                 input [ Type "button"
                         ClassName "btn btn-primary m-0"
                         OnClick ( fun _ -> dispatch FetchInvocies)
                         Value "Suchen" ] ] ]
let inline InvoiceSearchFormComponent placeholder dispatch =
    (ofFunction invoiceSearchForm) ({placeholder = placeholder; dispatch=dispatch }:InvoiceSearchFormComponentProps) []

let view model dispatch =
    card (Some (str "Rechnungen")) (span [] [ InvoiceSearchFormComponent model.Searchterm dispatch
                                              InvoiceListComponent model.Invoices false (fun _ -> ()) model.SortOption (fun newOption -> dispatch (Msg.UpdateSortOption newOption) ) ] )